import { addToCart } from '@/redux/slices/cart.slice';
import { setOrderType } from '@/redux/slices/checkout.slice';
import Modal from '@/components/global/Modal';
import { isPreorderOnlyCake, truncateText } from '@/utils/helpers';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { MdOutlineAddShoppingCart } from 'react-icons/md';

export default function MenuItemCard({ menuItem }: { menuItem: any }) {
  const dispatch = useDispatch();
  const [showPreorderModal, setShowPreorderModal] = useState(false);
  const isPreorderItem = isPreorderOnlyCake(menuItem);
  const isAvailable =
    menuItem?.is_available && menuItem?.outlet_menu?.is_available;

  async function addItemToCart() {
    if (isAvailable) {
      const payload = {
        id: menuItem._id,
        quantity: 1,
        isCombo: menuItem.isCombo,
        cartData: menuItem,
      };
      try {
        dispatch(addToCart(payload));
      } catch (e) {
        console.log('===> issue with adding item to cart', e);
      }
    }
  }

  const handleSelect = () => {
    if (isPreorderItem) {
      setShowPreorderModal(true);
      return;
    }

    addItemToCart();
  };

  return (
    <>
      <Modal
        modalTitle="Pickup only!"
        openModal={showPreorderModal}
        closeModal={() => setShowPreorderModal(false)}
        shouldCloseOnOverlayClick={false}
        closeButton={false}
      >
        <div className="grid gap-6">
          <p className="text-sm text-gray-600">
            At this time, the 2500 Bento Cake is only available for pickup and not delivery at the outlet you choose to order from.
          </p>
          <div className="grid gap-3 sm:flex">
            <button
              type="button"
              className="w-full rounded-full bg-crunchies-red px-5 py-3 text-sm font-medium text-crunchies-white"
              onClick={async () => {
                dispatch(setOrderType('pickup'));
                await addItemToCart();
                setShowPreorderModal(false);
              }}
            >
              okay, I will pickup
            </button>
            <button
              type="button"
              className="w-full rounded-full border border-gray-300 px-5 py-3 text-sm font-medium text-gray-700"
              onClick={() => setShowPreorderModal(false)}
            >
              cancel
            </button>
          </div>
        </div>
      </Modal>

      <div className="rounded-xl relative bg-white shadow-lg">
        {!isAvailable && (
          <div className="bg-crunchies-red absolute top-0 text-sm px-3 rounded-tl-xl rounded-br-xl w-max text-crunchies-white">
            Not Available
          </div>
        )}

        <div className={`${!isAvailable && 'opacity-10'}`}>
          <div className="bg-crunchies-neutral rounded-t-xl">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={menuItem?.image_url}
              className="w-full h-40 rounded-t-xl object-cover"
              alt={menuItem?.name}
            />
          </div>

          <div className="p-5 flex flex-col gap-1 justify-between h-48">
            <h3 className="text-xs md:text-base">
              {truncateText(menuItem?.name, 35)}
            </h3>

            <p className="text-xs">{truncateText(menuItem?.description, 65)}</p>

            <div className="grid gap-2 md:flex items-center justify-between">
              <p className="font-bold flex items-center gap-2 md:grid">
                <span className="text-xs text-gray-400">Price</span>
                <span className="text-crunchies-red text-sm">
                  &#8358; {menuItem?.outlet_menu?.price.toLocaleString()}
                </span>
              </p>
              <button
                className={`text-crunchies-white bg-crunchies-red px-5 py-3 rounded-full shadow-lg flex gap-2 items-center ${!isAvailable ? 'cursor-not-allowed opacity-50' : ''}`}
                onClick={handleSelect}
                disabled={!isAvailable}
              >
                <MdOutlineAddShoppingCart />
                <div className="text-xs">Select</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
